<template>
  <div class="top-column">
    <div
      class="top-column-inner inner-media-width yd-display-flex yd-justifyContent-s"
    >
      <span>广州市森锐科技股份有限公司</span>
      <ul>
        <li>股票代码：<em class="blue">839182</em></li>
        <li>电话：<em class="blue">020-38488825</em></li>
        <li @click="loginEvent">
          <a href="javascript:;" class="blue">登录</a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "topColumn",
  methods: {
    loginEvent() {
      if (window.ActiveXObject || "ActiveXObject" in window) {
        this.$confirm(
          "为了更好的浏览效果，请前往其他浏览器打开（" +
            "http://demo.esaleb.com:8680/admin" +
            "）",
          "温馨提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        );
      } else {
        window.open("http://demo.esaleb.com:8680/admin", "_blank");
      }
    },
  },
};
</script>

<style scoped>
.top-column {
  width: 100%;
  background: #fff;
  border-bottom: 1px solid #f5f5f5;
  font-size: 12px;
}
.top-column-inner {
  width: 1200px;
  margin: 0 auto 0 auto;
  color: #666666;
  box-sizing: border-box;
  line-height: 30px;
}
.top-column-inner span {
  font-size: 11px;
}
.top-column-inner ul li {
  margin-left: 20px;
  display: inline-block;
  font-size: 11px;
}
.top-column-inner ul li .blue {
  color: #2e81e1;
}
</style>



// WEBPACK FOOTER //
// src/components/myHeader/components/topColumn.vue